const DAYS = [
  { v: 0, l: "L" }, { v: 1, l: "M" }, { v: 2, l: "M" },
  { v: 3, l: "J" }, { v: 4, l: "V" }, { v: 5, l: "S" }, { v: 6, l: "D" },
];

export default function WeekdayPicker({ value = [], onChange }) {
  const toggle = (d) => {
    const set = new Set(value);
    if (set.has(d)) set.delete(d); else set.add(d);
    onChange([...set].sort((a, b) => a - b));
  };
  return (
    <div className="flex gap-1.5" data-testid="weekday-picker">
      {DAYS.map((d) => {
        const active = value.includes(d.v);
        return (
          <button
            key={d.v}
            type="button"
            onClick={() => toggle(d.v)}
            data-testid={`weekday-${d.v}`}
            className={`w-9 h-9 rounded-md font-semibold text-sm transition border ${active ? "bg-lx-primary text-white border-lx-primary" : "bg-white text-lx-muted border-lx-border hover:border-lx-primary/40"}`}
          >
            {d.l}
          </button>
        );
      })}
    </div>
  );
}
